(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["awareness-ribbon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('awareness-ribbon')) {
    customElements.define('awareness-ribbon', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.pageScroller = document.querySelector('.page-wrapper');
        this.update = () => {
          this.link.hidden = Math.max(window.scrollY, this.pageScroller?.scrollTop || 0) < 280;
        };
        window.addEventListener('scroll', this.update, { passive: true });
        this.pageScroller?.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.update);
        this.pageScroller?.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
